import { jsxs as N, jsx as s } from "react/jsx-runtime";
import { forwardRef as I, useId as v } from "react";
import { tv as g } from "tailwind-variants";
const i = g({
  slots: {
    wrapper: [
      "relative",
      "focus-within:outline-dotted",
      "focus-within:outline-cyan-500",
      "focus-within:outline-[3px]",
      "inline-block",
      "items-center"
    ],
    input: ["sr-only", "peer"],
    label: [
      "block",
      "cursor-pointer",
      "font-secondary",
      "font-semibold",
      "leading-relaxed",
      "pl-[2.4rem]",
      "before:rounded-sm",
      "before:border-[3px]",
      "before:text-white",
      "before:h-[1.625rem]",
      "before:w-[1.625rem]",
      "before:left-0",
      "before:absolute",
      "before:border-blue-500",
      "before:text-center",
      "before:top-1/2",
      "before:-translate-y-1/2",
      "peer-checked:before:bg-blue-500",
      "peer-checked:before:[background-image:theme(backgroundImage.iconCheck)]"
    ]
  },
  variants: {
    isDisabled: {
      true: {
        wrapper: ["opacity-50"],
        label: ["cursor-not-allowed"]
      }
    },
    level: {
      primary: {
        label: ["font-semibold"]
      }
    }
  }
}), c = I(
  ({
    ariaDescribedby: a,
    ariaLabel: b,
    checked: d,
    className: f,
    defaultChecked: p,
    disabled: t,
    label: n,
    name: u,
    onBlur: m,
    onChange: e,
    tagName: y = "div",
    value: r
  }, k) => {
    const o = v(), {
      wrapper: x,
      input: w,
      label: h
    } = i({ isDisabled: t });
    return /* @__PURE__ */ N(y, { className: x(), children: [
      /* @__PURE__ */ s(
        "input",
        {
          "aria-describedby": a,
          "aria-label": b,
          className: w(),
          checked: d,
          disabled: t,
          defaultChecked: p,
          id: o,
          name: u,
          onBlur: m,
          onChange: (l) => {
            if (!r) return e == null ? void 0 : e(l.target.checked);
            e == null || e(l.target.checked ? r : null);
          },
          ref: k,
          type: "checkbox",
          value: typeof r == "string" ? r : void 0
        }
      ),
      /* @__PURE__ */ s("label", { className: h({ class: f }), htmlFor: o, children: n })
    ] });
  }
);
c.displayName = "CheckboxInput";
c.styles = i;
export {
  c as default
};
